<template>
    <div class="base-create-footer">
      <tertiary-button
        v-if="primaryPreviousActive"
        @click.native="handlePrimaryPreviousClick"
      >
        {{ previousText }}
      </tertiary-button>
      <primary-button
        v-loading="primaryLoading"
        @click.native="handlePrimaryClick"
        :disabled="primaryDisabled"
        class="ml-auto"
      >
        {{ primaryText }}
      </primary-button>
    </div>
</template>

<script>
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'

  import { identity } from 'ramda'
  export default {
    components: {
      PrimaryButton,
      TertiaryButton,
    },
    props: {
      title: String,
      primaryAction: {
        type: Function,
        default: identity,
      },
      primaryPreviousAction: {
        type: Function,
        default: identity,
      },
      primaryDisabled: {
        type: Boolean,
        default: false,
      },
      primaryPreviousActive: {
        type: Boolean,
        default: true,
      },
      primaryText: {
        type: String,
        default: ''
      },
      previousText: {
        type: String,
        default: ''
      },
      primaryLoading: {
         type: Boolean,
         default: false,
       }
    },
    methods: {
      handlePrimaryClick() {
        this.primaryAction()

      },
      
      handlePrimaryPreviousClick() {
        this.primaryPreviousAction()
      }
    },
  }
</script>

<style lang="scss" scoped>
.base-create-header {
  h2 {
    font-weight: 800;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #121131
  }
}

.base-create-body {
  margin-top: 48px;
}

.base-create-footer {
    float: right;
    button {
        height: 40px;
    }
}
.elsa-purple-button.el-button {
  padding: 10px 23px;
  margin-left: 20px !important;
  // width: 208px;
}
.el-button+.el-button {
  margin-left: 20px !important;
}
.elsa-primary-button.el-button {
    min-width: 278px;
}
.elsa-flat-button.el-button {
  padding: 0;
  margin: 0;
  min-width: 278px;
  &:hover {
    background-color: transparent;
  }
}

</style>
